import React, { useState, useEffect } from 'react';
import { Table, Button, Space, DatePicker, Tag, Modal, Tooltip, Card, Row, Col, Input, Flex } from 'antd';
import { Pagination } from "@mui/material";
import { useSelector } from 'react-redux';
import { DeleteFilled, EditOutlined, EditTwoTone, EyeOutlined, FilterOutlined, InfoCircleOutlined, InfoCircleTwoTone, PlusCircleFilled, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { showMessage } from '../../Components/Utils/message';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import dayjs from 'dayjs';
import { Grid } from '@mui/material';
import AuthService from '../../Components/auth/AuthService';
import { encodeId } from '../../Components/common/CommonFun';
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, EXPIRATION_TIME } from '../../Components/common/Constants';
import { styled } from '@mui/system';
import ProductInfoModal from '../../Components/Modals/ProductInfoModal';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService()
const TransferStockList = () => {
    const { products, locations, roles, type: roleType } = useSelector((state) => state?.AppState?.userCreds);
    const [allTransfers, setAllTransfers] = useState([]);
    const navigate = useNavigate();
    const layoutDispatch = useLoadingDispatch();

    const [modalVisibleProduct, setModalVisibleProduct] = useState(false);
    const [selectedProductDetails, setSelectedProductDetails] = useState({
        totalStock: 0,
        code: '',
        name: '',
        productDetails: [],
        selectedRecord: null
    });
    const canAccess =
        roleType === 0 ||
        roleType === 1 ||
        (roleType === 2 && roles?.some((role) => role.role_id === 4));

    const [totalPages, setTotalPages] = React.useState(0);
    const [limit] = React.useState(50);
    const [totalCount, setTotalCount] = React.useState(null);
        
         const { RangePicker } = DatePicker;
        
          const [filters, setFilters] = React.useState(() => {
            const existing = localStorage.getItem('TransactionTransferStockFilters');
            const parsed = existing ? JSON.parse(existing) : {};
            const currentTime = new Date().getTime();

            const defaultFilters = {
                dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
                batchCode: '',
                page: 1
            };

            if (parsed.timestamp && currentTime - parsed.timestamp < EXPIRATION_TIME) {
                if (parsed.dateRange) {
                    parsed.dateRange = [
                        parsed.dateRange[0] ? dayjs(parsed.dateRange[0]) : defaultFilters.dateRange[0],
                        parsed.dateRange[1] ? dayjs(parsed.dateRange[1]) : defaultFilters.dateRange[1]
                    ];
                }
                return { ...defaultFilters, ...parsed };
            }
            localStorage.removeItem('TransactionTransferStockFilters');
            return defaultFilters;
        });

        const updateFilters = (newValues) => {
            const existingString = localStorage.getItem('TransactionTransferStockFilters');
            const existing = existingString ? JSON.parse(existingString) : {};

            Object.assign(existing, newValues);
            existing.timestamp = new Date().getTime();

            localStorage.setItem('TransactionTransferStockFilters', JSON.stringify(existing));
        };

    const getTransfers = async () => {
        showLoading(layoutDispatch);
        const dataToSend = {
              limit: limit,
              page: filters.page,
            }
            if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
              dataToSend.start_date = dayjs(filters?.dateRange[0]).format(DEFAULT_DATE_FORMAT);
              dataToSend.end_date = dayjs(filters?.dateRange[1]).format(DEFAULT_DATE_FORMAT);
            }
            if (filters?.batchCode) {
              dataToSend.searchText = (filters?.batchCode || '').trim();
            }
        try {
            const res = await Auth.post(`/stock/all-transfer-stocks`, dataToSend);
            if (res?.ack) {
                const transfers = res?.transfer_stocks || [];
                const total = res?.total_count || transfers.length || 0;
                setAllTransfers(transfers);
                setTotalPages(Math.ceil(total / limit));
                setTotalCount(total);
            } else {
                setAllTransfers([]);
                showMessage('error', res?.message);
            }

        } catch (err) {
            console.log(err);
            showMessage('error', 'Something went wrong while fetching ');
            setAllTransfers([]);
        }
        finally {
            hideLoading(layoutDispatch);
        }
    }

    const handleChange = (event, value) => {
        setFilters(prev => ({ ...prev, page: value }));
        updateFilters({ page: value });
    };

    const handleModalCancelProduct = () => {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: '', name: '', productDetails: [], selectedRecord: null });
        setModalVisibleProduct(false);
    }

    const handleInfoClick = async (record) => {
        const product = products?.find((item) => item?.netsuite_id == record?.product_netsuite_id);
        showLoading(layoutDispatch)
        try {

            const res = await Auth.fetch(`/product/product-details?id=${record?.product_netsuite_id}`)
            if (res?.ack) {
                if (res?.product_details.length > 0) {
                    const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
                    setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details, selectedRecord: product });
                    setModalVisibleProduct(true);
                    hideLoading(layoutDispatch)

                } else {
                    showMessage('error', 'No Details');
                    hideLoading(layoutDispatch)
                }
            } else {
                setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
                showMessage('error', res?.message)
                hideLoading(layoutDispatch)

            }

        } catch (error) {
            showMessage('error', 'something went wrong');
            hideLoading(layoutDispatch)
        }
    };

    useEffect(() => {
        getTransfers();
    }, [filters]);

    const columns = [


        {
            title: 'Code',
            width: 120,
            render: (record) => {
                return (
                    <span>{record?.transfer_stock_code || ''}</span>
                );
            }
        },
        {
            title: 'Product',
            width: 200,
            render: (record) => {
                const product = products?.find(pro => pro?.netsuite_id == record?.product_netsuite_id);
                return (
                    <Flex gap={5} align="center">
                        <Tooltip title={'Product Info'}>
                            <InfoCircleTwoTone
                                style={{ fontSize: '22px', cursor: 'pointer', padding: '2px' }}
                                onClick={() => handleInfoClick(record)}
                            />
                        </Tooltip>
                        <Tooltip title={product?.name}>
                            <span
                                style={{
                                    maxWidth: 200,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'inline-block',
                                }}
                            >
                                {`${product?.code} - ${product?.name}`}

                            </span>
                        </Tooltip>
                    </Flex>
                );
            }
        },
        {
            title: 'Source Location',
            width: 120,
            render: (record) => {
                const source = locations?.find(loc => loc?.id === record?.source_location_id);
                return (
                    <span>{`${source?.code}`}</span>
                );
            }
        },
        
        {
            title: 'Destination Location',
            width: 160,
            render: (record) => {
                const source = locations?.find(loc => loc?.id === record?.dest_location_id);
                return (
                    <span>{`${source?.code}`}</span>
                );
            }
        },
        {
            title: 'Quantity',
            width: 100,
            render: (record) => {
                return (
                    <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.quantity)?.toLocaleString() || 0} </Tag>
                    
                );
            }
        },
        {
            title: "User",
            width: 150,
            render(record) {
                if (!record) return "";

                const user = record?.user_name || "";
                const helper = record?.helper_name || "";

                if (helper) {
                    return (
                        <>
                            {helper}{" "}
                            {user && (
                                <Tooltip title={`${user}`}>
                                    <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                                </Tooltip>
                            )}
                        </>
                    );
                }

                return <>{user}</>;
            }
        },
        {
            title: 'Date',
            width: 150,
            render: (record) => {
                return (
                    <span>{record?.createdAt ? dayjs(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : ''}</span>
                );
            }
        },
        {
            title: 'Action',
            key: 'action',
            align: 'right',
            width: 100,
            render: (text, record) => (
                <div>
                    <Tooltip title="View Details">
                        <EyeOutlined
                            style={{
                                fontSize: "24px",
                                cursor: "pointer",
                                marginRight: "5px",
                                color: "#006cb8",
                            }} onClick={() => {
                                    const hasedID = encodeId(record?.id)

                                navigate(`/transaction-transfer/${hasedID}`)}} />
                    </Tooltip>
                    

                </div>
            ),
        }

    ];

    return (
        <DataSheet>   
           <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Transfer Stock</>}
                style={{ marginBottom: '10px' }}
                extra={
                <>
                    <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF", }} onClick={() => navigate("/stocks/transfer-stock")} />
                </>
                }
            >
                <Row gutter={[6, 1]}>
                    <Col xs={24} md={12} lg={8}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
                        <RangePicker
                            style={{ width: '100%' }}
                            value={filters.dateRange}
                            onChange={(dates) => {
                                setFilters(prev => ({ ...prev, dateRange: dates, page: 1 }));
                                updateFilters({ 
                                  dateRange: dates ? [dates[0] ? dates[0].format(DEFAULT_DATE_FORMAT) : null, dates[1] ? dates[1].format(DEFAULT_DATE_FORMAT) : null] : null,
                                  page: 1 
                                });
                            }}
                            format={DATE_FORMAT}
                            allowClear={false}
                        />
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
                        <Input
                            placeholder="Search"
                            value={filters.batchCode}
                            onChange={(e) => {
                                const val = e.target.value;
                                setFilters(prev => ({ ...prev, batchCode: val, page: 1 }));
                                updateFilters({ batchCode: val, page: 1 });
                            }}
                        />
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <Space style={{ width: '100%', marginTop: '25px' }}>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={() => getTransfers()}
                            >
                                Search
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Card>

            <Table
                columns={columns}
                dataSource={allTransfers}
                pagination={false}
                footer={() => {
                    const currentTotal = totalCount || 0;
                    const startRecord = allTransfers?.length > 0 ? (filters.page - 1) * limit + 1 : 0;
                    const endRecord = Math.min(filters.page * limit, currentTotal);
                    return `Showing ${startRecord}-${endRecord} of ${currentTotal} Records`;
                }}
                scroll={{ x: 'max-content' }}
                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
            />
            <div style={{ float: "right", margin: "10px" }}>
                <Pagination
                    page={filters.page}
                    count={totalPages}
                    variant="outlined"
                    color="primary"
                    onChange={handleChange}
                />
            </div>
            <ProductInfoModal
                visible={modalVisibleProduct}
                onCancel={handleModalCancelProduct}
                selectedItemDetails={selectedProductDetails}
                selectedItems={selectedProductDetails?.productDetails}
                selectedRecord={selectedProductDetails?.selectedRecord}
            />
        </DataSheet>
    );
};

export default TransferStockList;